// extracted by mini-css-extract-plugin
export var headerCell = "_1s-1";
export var loadingSpinnerContainer = "_1s-4";
export var rowWrapper = "_1s-3";
export var standaloneTable = "_1s-5";
export var table = "_1s-0";
export var white = "_1s-2";